// @flow
import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import clone from 'ramda/es/clone';
import prop from 'ramda/es/prop';
import omit from 'ramda/es/omit';

import api from 'app/actions/api';
import action from 'app/common/lib/action';

import { defaultBalanceState } from './AccountBalanceContext';
import type { AccountBalanceType } from './AccountBalanceTypes';


export default function useBalance() {
  const dispatch = useDispatch();
  const { t } = useTranslation('finances');
  const [balance, setBalance] = useState<AccountBalanceType>(defaultBalanceState);
  const [balanceLoading, setBalanceLoading] = useState(false);

  const balanceRequest = useCallback(async () => {
    const requestPath = 'account/balance';
    const type = 'get';
    try {
      setBalanceLoading(true);
      const res = await api(requestPath, type);
      const balanceResult: AccountBalanceType = omit('result', prop('data', res)) || defaultBalanceState;
      setBalance(balanceResult);
      setBalanceLoading(false);
    } catch (error) {
      const errorSave = {
        err: t('request_finances_balance_failed'),
        path: requestPath,
        type,
        error: clone(error),
      };
      dispatch(action('REQUEST_FAILURE', errorSave));
    }
  }, [dispatch, t]);

  return [balance, balanceRequest, balanceLoading];
}
